import {
  DROP_PROMISED_PAYMENT_DATA,
  RESET_PROMISED_PAYMENT_DATA,
  SET_PROMISED_PAYMENT_DATA,
  SET_PROMISED_PAYMENT_FILTERS,
  SET_PROMISED_PAYMENT_SETTINGS,
  SET_TAKEN_PROMISED_PAYMENT_DATA,
} from 'modules/Finance/PromisedPayment/store/types'
import setFilters from 'store/reducer-utils/setFilters'

const initialState = {}

const setSettings = (state, { payload }) => ({
  ...state,
  settings: { ...(state?.settings ?? {}), ...payload },
})

const setData = (state, { payload }) => ({
  ...state,
  promisedPayment: {
    ...(state?.promisedPayment ?? {}),
    ...payload,
  },
})

const dropData = (state) => ({
  ...state,
  promisedPayment: { ...(state?.promisedPayment ?? {}), data: [] },
})

const resetData = () => ({
  ...initialState,
})

const setPromisedPaymentFilters = (state, action, force = false) => {
  const filteredPayload =
    state?.filters && !force
      ? [...action.payload].filter(
          (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
        )
      : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setTakenPromisedPayment = (state, { payload }) => ({
  ...state,
  takenPromisedPayment: { ...(state?.takenPromisedPayment ?? {}), ...payload },
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROMISED_PAYMENT_SETTINGS:
      return setSettings(state, action)
    case SET_PROMISED_PAYMENT_DATA:
      return setData(state, action)
    case DROP_PROMISED_PAYMENT_DATA:
      return dropData(state, action)
    case RESET_PROMISED_PAYMENT_DATA:
      return resetData(state, action)
    case SET_PROMISED_PAYMENT_FILTERS:
      return setPromisedPaymentFilters(state, action)
    case SET_TAKEN_PROMISED_PAYMENT_DATA:
      return setTakenPromisedPayment(state, action)
    default:
      return state
  }
}

export default reducer
